import { Lesson } from "@jelly/lesson";

import principle01 from "./layouts/principle-01/principle";
import task01 from "./layouts/task-01/task";
import task02 from "./layouts/task-02/task";

const lesson: Lesson = {
  id: "26f93e78-23bf-4794-9c45-6d7007fdf8d7",
  publicId: "22",
  name: "Stereo Vector-Base-Amplitude Panning",
  difficulty: 2,
  contentTypes: { audio: true, interactive: true, video: false },
  body: [principle01, task01, task02],
};

export default lesson;
